import { LIVE_CLASS_LOCKED_STATE_KEYS } from '../../../shared/types/live-class-locked-state-keys';
import { LiveClassEventDto } from '../../live-class-event-dto';
import { FREE_FORM_LESSON_UUID } from '../../live-class-revamp/private-class-banner/private-class-download-slides-link/private-class-download-slides-link.component';
import { PrivateClassLesson } from '../../live-class-revamp/private-class-banner/private-class-lesson-dto';
import { LiveClassTile } from './live-class-tile';

export class PrivateClassTile extends LiveClassTile {
  public selectedLesson: PrivateClassLesson | null = null;

  protected selectLesson(lessonsWithFreeFormTopic?: PrivateClassLesson[]): void {
    this.selectedLesson = null;
    const lesson = lessonsWithFreeFormTopic.filter((lesson) => lesson.uuid !== FREE_FORM_LESSON_UUID);
    const autoSelectLesson = lesson.length === 1;
    if (autoSelectLesson) {
      this.selectedLesson = lesson[0];
      this.confirmSignUp();
    } else {
      super.selectLesson();
    }
  }

  protected onComplete(): void {
    this.liveClassEventSubscription.unsubscribe();
    this.setLockedState(LIVE_CLASS_LOCKED_STATE_KEYS.PC_COMPLETE[this.pcRevampType]);
  }

  protected onLessonSelectEvent(event: LiveClassEventDto): void {
    if (this.liveClass && event.data === this.liveClass.id) {
      this.currentState = 'SIGNUP_LESSON_SELECTION';
    } else {
      this.setLockedState(LIVE_CLASS_LOCKED_STATE_KEYS.SUBSCRIBE[this.pcRevampType]);
    }
  }

  public get selectedLessonId(): number | null {
    if (!this.selectedLesson) {
      return null;
    }
    return this.selectedLesson.id;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/class-tile/private-class-tile.ts